<template>
    <div class="wrapper wrapper-full-page">
        <div class="full-page" data-color="black">
            <!--   you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " -->
            <div class="content" :style="displayNone">
                <div class="container">
                    <div class="col-sm-8 col-md-6 ml-auto mr-auto">
                        <div class="card card-login">
                            <div class="card-header ">
                                <h3 class="header text-center"><i class="fa fa-lock"></i>Тизимга кириш</h3>
                            </div>
                            <div class="card-body" v-if="!isLoggingInViaKeycloak">

                                <div class="card-body" v-if="isLoginViaDefaultWay">
                                  <form action="#" v-on:submit.prevent="logIn">
                                    <div class="form-group">
                                        <label>Логин</label>
                                        <input type="text" placeholder="Логин..." class="form-control" v-model="user.username" @keyup="logInReset">
                                    </div>
                                    <div class="form-group">
                                        <label>Пароль</label>
                                        <div class="input-group">
                                          <input
                                              :type="showPassword ? 'text' : 'password'"
                                              placeholder="Пароль..."
                                              class="form-control"
                                              v-model="user.password"
                                              @keyup="logInReset"
                                          >
                                          <div class="input-group-append">
                                            <button class="btn mb-0" type="button" @click="showPassword = !showPassword">
                                              <i class="fa fa-eye-slash" v-if="showPassword"/>
                                              <i class="fa fa-eye" v-else/>
                                            </button>
                                          </div>
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="loginError && loginError.length > 0"
                                        style="text-align:center;color:red;margin-top:10px">
                                        {{loginError}}
                                    </div>
                                    <br/>
                                    <div class="ml-auto mr-auto">
                                      <button type="submit" class="all-btn edit-btn btn-wd w-100" style="margin-top: 10px">Кириш</button>
                                    </div>
                                  </form>
                                </div>

                                <template v-if="!isLoginViaDefaultWay">

                                  <div class="card-body">
                                    <div class="ml-auto mr-auto">
                                      <button class="all-btn edit-btn btn-lg w-100" @click="handleLoginViaDefaultWay">
                                        Оддий усулда кириш
                                      </button>
                                    </div>
                                  </div>

                                  <div class="card-body">
                                    <div class="ml-auto mr-auto">
                                      <button class="all-btn keycloak-btn btn-lg" @click="loginViaKeycloak">
                                        <img src="../assets/images/keycloak-logo.svg" alt="keycloak-logo.svg" class="keycloak-logo"/>
                                        Keycloak орқали кириш
                                      </button>
                                    </div>
                                  </div>

                                </template>

                            </div>

                            <div class="card-body" v-if="isLoggingInViaKeycloak">
                              <loading2/>
                            </div>
                            <div class="card-footer ml-auto mr-auto">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import Loading2 from "@/views/Loading2.vue";
    import {ARCHIVE_MODE_VERSION, LOGGING_METHOD} from "@/store";
    import Cookie from "js-cookie";
    import {LOGIN_METHOD} from "@/shared/constants/loginMethod";

    export default {
        components: {Loading2},
        data() {
            return {
                loading: false,
                displayNone: 'display: none',
                user: {
                    username: '',
                    password: ''
                },
                isLoginViaDefaultWay: false,
                showPassword: false
            }
        },
        computed: {
            ...mapState(['loginProgress', 'loginError', 'isLoggingInViaKeycloak', 'isLoggedIn'])
        },
        methods: {
            logIn() {
                this.$store.dispatch('logIn', this.user);
            },
            logInReset() {
                this.$store.dispatch('logInReset');
            },
            loginViaKeycloak() {
              this.$store.dispatch('authenticateViaKeycloak')
            },
            handleLoginViaDefaultWay() {
              this.isLoginViaDefaultWay = true
            },
            checkIfArchiveModeEnabled() {
              let archiveVersionFromCookie = Cookie.get('archive_version')
              if(this.$route.query && (this.$route.query.archiveVersion || archiveVersionFromCookie)) {
                this.$store.commit(ARCHIVE_MODE_VERSION, (this.$route.query.archiveVersion || archiveVersionFromCookie || ''));
              } else if(!this.isLoggedIn) {
                this.$store.commit(ARCHIVE_MODE_VERSION, '');
              }
            },
            checkIfLoggedInViaKeycloak() {
              if(this.$router.currentRoute && this.$router.currentRoute.query && this.$router.currentRoute.query.loggedViaKeycloak && this.$router.currentRoute.query.loggedViaKeycloak === 'true') {
                this.$store.dispatch('authenticateViaKeycloak')
              }
            },
            initLoginMethod() {
              let loginMethod = (Cookie.get('login_method') || LOGIN_METHOD.SIMPLE)
              this.$store.commit(LOGGING_METHOD, loginMethod);
              if(loginMethod === LOGIN_METHOD.KEYCLOAK) {
                this.$store.dispatch('authenticateViaKeycloak');
              }
            }
        },
        mounted() {
          setTimeout(() => {
            this.displayNone = '';
          }, 1000);

          this.initLoginMethod()
          this.checkIfArchiveModeEnabled()
          this.checkIfLoggedInViaKeycloak()
        }
    }
</script>


<style>
    /* .login-page {
        background-image: url('./assets/images/login_bg.jpg'); 
        background-size: cover; 
        background-position: top center;
    } */
    .login-page {
        background: linear-gradient(#546E7A, #455A64);
    }
</style>
